export const getTPsAPI="/training-programs";
export const sendTPSuggestionAPI="/training-program-suggestion";
export const getTPSuggestingStatusAPI="/training-program-suggestions/status";
export function getTrainingProgramAPI(id){return `/training-programs/${id}`;}
export const getTrainingProgramQuestionsAPI="/training-program-questions";
export function sendTrainingProgramApplicationAPI(id){ return `/training-programs/${id}/apply`;}